<template>
    <div id="invocingManage">
        <el-form ref="searchForm" :model="searchForm" style="width:100%" :inline="true" :label-position="labelPosition">
            <el-form-item style="width:100px;margin-bottom:15px">
                <el-select filterable v-model="searchForm.status" placeholder="请选择开票状态" clearable>
                    <el-option v-for="(item,index) in pickingStatusList" 
                        :label="item.paraName" 
                        :value="item.paraCode" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:110px;margin-bottom:15px">
                <el-select filterable v-model="searchForm.type" placeholder="开票类型" clearable>
                    <el-option v-for="(item,index) in pickingTypeList" 
                        :label="item.paraName" 
                        :value="item.paraCode" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:150px;margin-bottom:15px">
                <el-input clearable v-model.trim="searchForm.orderNo" placeholder="订单编号"></el-input>
            </el-form-item>
             <el-form-item style="width:140px;margin-bottom:15px">
                <el-input clearable v-model.trim="searchForm.invoiceCode" placeholder="开票申请编号"></el-input>
            </el-form-item>
            <el-form-item style="width:140px;margin-bottom:15px">
                <el-select filterable clearable v-model="searchForm.staffName" placeholder="申请人">
                    <el-option v-for="(item,index) in pickingUserAllList" 
                        :label="item.staffName" 
                        :value="item.staffName" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:350px;margin-bottom:15px">
                <el-date-picker
                    v-model="valueTime3"
                    type="daterange"
                    range-separator="-"
                    :default-time="['00:00:00', '11:59:59']"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item style="margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit('searchForm')">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
            </el-form-item>
            <el-form-item class="fr">
                <el-col style="text-align:right">
                    <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                </el-col>
            </el-form-item>
        </el-form>
        <el-card class="box-card " style="width: 100%;">
            <el-table
                :data="returnData"
                border
                id="tableId"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"                       
                    label="开票申请编号">
                    <template slot-scope="scope">
                        <span class="active-code" @click="checkModel(scope.row)">{{scope.row.invoiceCode}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="orderNo"
                    width="200"
                    label="关联订单号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="invoiceAmount"
                    label="开票金额(元)">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == '1'">专票</span>
                        <span v-if="scope.row.type == '2'">普票</span>
                        <span v-if="scope.row.type == '3'">电子普票</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="dutyParagraph"
                    align="center"
                    label="纳税人编号">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="开票状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == '2'">审核中</span>
                        <span v-if="scope.row.status == '3'">已开票</span>
                        <span v-if="scope.row.status == '4'">已驳回</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="staffName"
                    align="center"
                    label="申请人">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="createTime"
                    label="提交时间">
                </el-table-column>
            </el-table>
        </el-card>
        <el-dialog :title="textModelMenu[dialogModelStatus]" :visible.sync="dislogModel" :close-on-click-modal="false" width="600px" :modal-append-to-body="false"  @close="emptyModelDialog('modelForm')">
            <el-form ref="modelForm" :model="modelForm" label-width="100px" :label-position="labelPosition" >
                <div v-if="!isReject">
                    <el-form-item label="关联工单" prop="orderNo">
                        <el-input clearable disabled v-model.trim="modelForm.orderNo" placeholder="请输入关联工单"></el-input>
                    </el-form-item>
                    <el-form-item label="开票类型" prop="type">
                        <el-select disabled v-model="modelForm.type" placeholder="请选择开票类型" style="width: 100%;" clearable>
                            <el-option v-for="(item,index) in pickingTypeList" 
                                :label="item.paraName" 
                                :value="item.paraCode" 
                                :key="index">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开票金额" prop="invoiceAmount">
                        <el-input disabled clearable v-model.trim="modelForm.invoiceAmount" class="yuan" placeholder="请输入开票金额"></el-input>
                    </el-form-item>
                    <el-form-item label="开票抬头" prop="invoiceTitle">
                        <el-input disabled clearable v-model.trim="modelForm.invoiceTitle" placeholder="请输入开票抬头"></el-input>
                    </el-form-item>
                    <el-form-item label="纳税编号" prop="dutyParagraph">
                        <el-input disabled clearable v-model.trim="modelForm.dutyParagraph" placeholder="请输入纳税编号"></el-input>
                    </el-form-item>
                    <el-form-item  label="相关图片">
                        <el-upload
                            action="https://up.qiniup.com"
                            class="avatar-uploader hide-upload"
                            ref="update"
                            disabled
                            list-type="picture-card"
                            :file-list="fileList"
                            :on-preview="handlePreview">
                        </el-upload>
                    </el-form-item>
                </div>
                <div v-if="isReject">
                    <el-form-item label="驳回原因" prop="attribute1">
                        <el-input clearable v-model.trim="modelForm.attribute1" type="textarea" placeholder="请输入驳回原因"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" v-if="!isReject && modelForm.status == '2'" class="dialog-footer" >
                <el-button type="success" v-if="basicsAuth.check_invoice" @click="isReject = true">驳回申请</el-button>
                <el-button type="success" v-if="basicsAuth.check_invoice" @click="confirmBtn(1)">开票成功</el-button>
            </span>
            <span slot="footer" v-if="isReject" class="dialog-footer" >
                <el-button type="success" @click="confirmBtn(0)">确认</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <!--分页-->
        <el-col :span="24" class="toolbar">
            <div class="pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pages.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pages.pageSize"
                    layout="total, sizes, prev, pager, next,jumper"
                    :total="pages.total">
                </el-pagination>
            </div>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import { queryInvoiceList,applyInvoice,checkInvoice,getOrderList } from "../../api/order";
    import {queryUser} from '@/api/api'
    import store from '../../store/store';
    import {genUpToken} from "../basicSetting/com/qiniuToken.js";
     import {getPermission} from '../../api/authRequest'
    export default {
        name: 'invocingManage',
        data () {
            return {
                valueTime3:"",
                pickingStatusList:[
                    {
                        paraName:'全部',
                        paraCode:''
                    },
                    {
                        paraName:'审核中',
                        paraCode:'2'
                    },
                    {
                        paraName:'已开票',
                        paraCode:'3'
                    },
                    {
                        paraName:'已驳回',
                        paraCode:'4'
                    }
                ],
                pickingTypeList:[
                    {
                        paraName:'个人',
                        paraCode:'1'
                    },
                    {
                        paraName:'企业',
                        paraCode:'2'
                    }
                ],
                pickingUserAllList:[],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                searchForm:{
                    status:'',          //开票状态
                    orderNo:'',         //订单号
                    type:'',            //开票类型 1=>个人 2=>公司
                    invoiceTimeFrom:'', //申请开始时间
                    invoiceTimeTo:'',   //申请结束时间
                    staffName:'',       //申请人姓名
                    invoiceCode: '',    //开票申请编号
                },
                returnData: [],
                dislogModel:false,      //开票详情弹出框显示状态
                dialogModelStatus: "",  //开票详情弹出框显示标题
                textModelMenu: {
                    update: "开票申请详情",
                    create: "新建开票申请"
                },
                fileList:[],         //图片查看
                dialogImageUrl:"",   //预览图片
                dialogVisible: false,//图片预览弹框显示状态
                isReject:false,      //是否驳回
                modelForm:{
                    orderNo: '',
                    type: '',
                    invoiceAmount: '',
                    dutyParagraph:'',
                    invoiceTitle: "",
                    picture:"",
                },
                basicsAuth:{
                    check_invoice:false
                }
                
            }
        },
       
        mounted () {
            this.basicsAuth.check_invoice= getPermission('/api/workOrder/invoice/check_invoice');
        },
        created(){
            this.getInvoiceList();
            this.queryUserAllList();
        },
        methods: {
            //查询所有系统账号
            queryUserAllList(){
                queryUser({type:2}).then(res =>{
                    if(res.data.status == '100'){
                        this.pickingUserAllList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //预览图片
            handlePreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            //关闭弹出框
            emptyModelDialog() {
                this.dislogModel = false;
                Object.keys(this.modelForm).forEach(key => this.modelForm[key]= '');
                this.$refs['modelForm'].resetFields();
                this.fileList = [];
                this.isReject = false;
            },
            confirmBtn(num){
                let message = num == 0 ? '确认驳回申请吗？' : '确认开票已完成吗？';
                this.$confirm(message, '提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    (num == 0) ? this.submitConfirmModel(0) : this.submitConfirmModel(1);
                }).catch(action => {
                    (num == 0) ? (this.isReject = false) : '';
                });
            },
            //开票确认 type:0 驳回 type:1确认
            submitConfirmModel(type){
                let para = {};
                if(type == 0){
                    if(!this.modelForm.attribute1){
                        this.$message({
                            message: '请输入驳回原因',
                            type: "warning"
                        });
                        return
                    }
                    para = {
                        id:this.modelForm.id,
                        status:"4",
                        attribute1:this.modelForm.attribute1
                    }
                }else{
                    para = {
                        id:this.modelForm.id,
                        status:"3",
                    }
                }
                checkInvoice(para).then(res => {
                    const loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)'
                    });
                    if (res.data.status==100) {
                        this.$message({
                            message: res.data.message,
                            type: "success"
                        });
                        /*关闭弹窗，重置输入框*/
                        this.emptyModelDialog();
                        /*刷新*/
                        this.getInvoiceList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                    loading.close();
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //查看开票详情
            checkModel(item) {
                this.dislogModel = true
                this.dialogModelStatus = "update";
                this.modelForm = Object.assign({}, item);
                this.fileList = [];
                if(this.modelForm.picture){
                    this.modelForm.picture.split(',').forEach((item,index)=>{
                        this.fileList.push({
                            name:'',
                            url:item
                        })
                    })
                }
            },
            //重置
            clearFrom(){
                Object.keys(this.searchForm).forEach(key => this.searchForm[key]= '');
                this.valueTime3 = "";
                this.getInvoiceList();
            },
            //获取开票申请管理列表
            getInvoiceList(){
                this.searchForm.startRow = this.pages.page;
                this.searchForm.pageSize = this.pages.pageSize;
                queryInvoiceList(this.searchForm).then(res => {          
                    if (res.data.status==100) {            
                            this.returnData = res.data.results.list
                            this.returnData.forEach((item,index)=>{
                                item.createTime = this.filters.formatDate(item.createTime)
                            })
                            this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getInvoiceList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getInvoiceList()
            },
            //刷新
            refresh() {
                this.clearFrom();
            },
            //
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        if(this.valueTime3 == null){
                            this.searchForm.invoiceTimeFrom = ''
                            this.searchForm.invoiceTimeTo = ''
                        }else if(this.valueTime3.length == 0){
                            this.searchForm.invoiceTimeFrom = ''
                            this.searchForm.invoiceTimeTo = ''
                        }else{
                            this.searchForm.invoiceTimeFrom = this.moment(this.valueTime3[0]).format("YYYY-MM-DD");
                            this.searchForm.invoiceTimeTo = this.moment(this.valueTime3[1]).format("YYYY-MM-DD");
                        }
                        this.getInvoiceList()
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            }
        },
        computed: {},
        watch: {}
    }
</script>
<style type="text/css" lang="scss">
    .hide-upload{
        .el-upload {
            display: none;
        }
    } 
</style>
<style type="text/css" lang="scss" scoped>
    
    #invocingManage{
        font-size: 14px;
        .headerT{
            margin:0 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px; 
        }
        .active-code{
            color:#409EFF
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: inline-block;
        }
        .yuan{
            position:relative;
            &:after{
                position:absolute;
                right:0;
                content:'元';
                font-size:14px;
                color:#666;
                line-height:40px;
                width:30px;
                height:40px;
                top:0;
                display:block
            }
        }
    }

</style>



// WEBPACK FOOTER //
// invocingManage.vue?5617a4b4